/** Shared shift helpers for scheduler + excel import */

import { isMagazaMuduru, isVardiyaMuduru } from './staffRoleUtils';

export function managersOnShift(shift, staffByAuthId) {
  const ids = Array.isArray(shift?.assigned_user_ids) ? shift.assigned_user_ids : [];
  return ids.filter((id) => isVardiyaMuduru(staffByAuthId[id]));
}

export function mdOnShift(shift, staffByAuthId) {
  const ids = Array.isArray(shift?.assigned_user_ids) ? shift.assigned_user_ids : [];
  return ids.filter((id) => isMagazaMuduru(staffByAuthId[id]));
}

export function collectDayManagers(shifts, staffByAuthId) {
  const vm = new Map();
  const md = new Map();
  (shifts || []).forEach((shift) => {
    (shift.assigned_user_ids || []).forEach((id) => {
      const member = staffByAuthId[id];
      if (!member?.full_name) return;
      const key = String(member.full_name).toLocaleLowerCase('tr-TR');
      if (isVardiyaMuduru(member)) vm.set(key, member.full_name);
      if (isMagazaMuduru(member)) md.set(key, member.full_name);
    });
  });
  return { vm: [...vm.values()], md: [...md.values()] };
}

/** @deprecated use managersOnShift — kept for callers expecting the old name */
export const vardiyaManagersOnShift = managersOnShift;
